import React from "react";
import { useCardModel } from "../cardModel";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useCardModel();
    const { getSelectedDictOne } = useDictModel(() => []);

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "部门",
            fieldName: "depName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "姓名",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "名片属性",
            fieldName: "cardType",
            options: getSelectedDictOne(DictCodeEnmu.CORD_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "名片状态",
            fieldName: "status",
            options: [{ label: "启用", value: "1" }, { label: "禁用", value: "0" }]
        }
    ]

    return (
        <YhPageHeader
            title="电子名片管理"
            justify="end"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}